<template>
    <div class="container">
        <img src="../../images/banner.jpg" alt="">
        <div class="ptitle-wrap company-ad">
            <div class="ptitle">建工优选</div>
            <div class="cd-box">
                <div class="ci-box">
                    <ul>
                        <li v-for="(item, index) in list" :key="index">
                            <div class="ci-box-item">
                                <div class="images"><img :src="item.image" alt="" width="286" height="190">
                                </div>
                                <div class="ctitle">{{item.name}}</div>
                                <div class="tip"><span>{{item.price}}</span>{{item.unit}}</div>
                                <div class="dask">
                                    <div class="dtitle">{{item.name}}</div>
                                    <div class="guding">
                                        <div class="dp" v-for="item1 in item.desc" :key="item1">
                                            <img class="bingo" style="width: 16px;" src="../../images/bingo.png" alt="">
                                            <span> {{item1}}</span>
                                        </div>


                                        <!-- <p class="dp" v-for="item1 in item.desc" :key="item1"><i
                                                class="icon">&#xe6aa;</i>{{item1}}</p> -->
                                    </div>
                                    <div class="d-tou" @click="toDetail(item.url)">立即投保</div>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data () {
            return {
                list: [
                    {
                        image: require('../../images/gzType.jpg'),
                        name: '建工雇主责任险按项目方案',
                        // desc: ['附加24小时意外', '附加自费药赔偿', '附加伤残赔偿比例调整'],
                        price: 3000,
                        unit: '元/项目起',
                        url: '/haierProduct.html#/customized-employer-liability'
                    },
                    {
                        image: require('../../images/tbType.jpg'),
                        name: '投标保证保险',
                        url: '/haierProduct.html#/customized-employer-liability/bidDetail'   
                    },
                    {
                        image: require('../../images/typeTwo.jpg'),
                        name: '装修保宝建筑工程一切险',
                        url: '/haierProduct.html#/customized-employer-liability/renovationDetail'   
                    },
                    {
                        image: require('../../images/allRisks.jpg'),
                        name: '建筑工程一切险',
                        url: '/haierProduct.html#/customized-employer-liability/allRisks'   
                    },
                    {
                        image: require('../../images/safeProduction.jpg'),
                        name: '建筑施工行业安全生产责任保险',
                        url: '/haierProduct.html#/customized-employer-liability/safeProduction'   
                    },
                    {
                        image: require('../../images/farmer.jpg'),
                        name: '农民工工资支付履约保证保险',
                        url: '/haierProduct.html#/customized-employer-liability/farmer'   
                    },
                    {
                        image: require('../../images/guarantee.jpg'),
                        name: '建设工程施工合同履约保证保险',
                        url: '/haierProduct.html#/customized-employer-liability/guarantee'   
                    },
                    {
                        image: require('../../images/proceeding.jpg'),
                        name: '诉讼财产保全责任保险',
                        url: '/haierProduct.html#/customized-employer-liability/proceeding'   
                    },
                ],
                policy: {},
                showModal: false
            }
        },
        mounted () {
            (function() {var _53code = document.createElement("script");_53code.src = "https://tb.53kf.com/code/code/0e08b839288f19ac3298ef1eb2ac29190/1";var s = document.getElementsByTagName("script")[0]; s.parentNode.insertBefore(_53code, s);})();
        },
        methods: {
            toDetail (url) {
                location.href = url
            }

        },
    }
</script>
<style scoped lang="less">
    .ptitle-wrap {
        text-align: center;
        padding: 60px 0;

        .ptitle {
            font-size: 36px;
            font-weight: bolder;
            font-stretch: normal;
            letter-spacing: 0px;
            color: #333333;
        }

        .ptitle.white {
            color: #fff;
        }

        .ptip {
            font-family: FZLTHJW--GB1-0;
            font-size: 16px;
            font-weight: normal;
            font-stretch: normal;
            letter-spacing: 1px;
            color: #999999;
            margin-top: 15px;
        }

        .ptip.white {
            color: #fff;
        }
    }

    .index-banner {
        position: relative;
        margin-top: 100px;

        .images {
            position: relative;
        }
    }

    .company-ad {
        width: 100%;
        background: #f4f4f4;
        padding-bottom: 88px;

        .cd-box {
            width: 1200px;
            margin: auto;

            .dingzhi {
                .dask {
                    width: 285px;
                    height: 320px;
                    background-color: #2768ef;
                    color: #fff;
                    padding: 26px;

                    .dtitle {
                        font-size: 20px;
                        font-weight: bold;
                        // margin: 20px;
                        margin-bottom: 15px;
                        text-align: left;

                        i {
                            font-size: 28px;
                            font-weight: 100;
                            float: right;
                            position: relative;
                            top: -4px;
                        }
                    }

                    .dp {
                        i {
                            margin-right: 5px;
                        }

                        font-size: 14px;
                        line-height: 26px;
                    }

                    .d-t {
                        font-size: 14px;
                        margin-top: 30px;
                    }

                    .d-tou {
                        width: 110px;
                        height: 40px;
                        line-height: 40px;
                        text-align: center;
                        background-color: #2768ef;
                        border-radius: 5px;
                        border: solid 1px #ffffff;
                        color: #fff;
                        cursor: pointer;
                        margin-top: 15px;
                    }
                }
            }
        }
    }

    .company-industry {
        width: 1200px;
        margin: auto;
        margin-bottom: 90px;

        .ci-tab {
            margin-bottom: 50px;

            ul {
                border: solid 1px #dddddd;
                display: flex;

                li {
                    text-align: center;
                    width: 171.5px;
                    padding: 24px 0;
                    transition: all 0.5s;
                    cursor: pointer;

                    i {
                        font-size: 32px;
                    }

                    p {
                        font-size: 16px;
                        // color: #333333;
                    }
                }

                li+li {
                    border-left: 1px solid #dddddd;
                }

                li:hover,
                .active {
                    color: #fff;
                    background: #2768ef;
                }
            }
        }
    }

    .ci-box {
        ul {
            display: flex;
            // justify-content: space-around;
            width: 100%;
            flex-wrap: wrap;

            li {
                .ci-box-item {
                    width: 285px;
                    height: 320px;
                    margin-bottom: 30px;
                    margin-right: 15px;
                    position: relative;
                    border: solid 1px #eeeeee;
                    overflow: hidden;

                    .ctitle {
                        font-size: 18px;
                        color: #333333;
                        padding: 0 20px;
                        margin-top: 20px;
                        margin-bottom: 5px;
                        text-align: left;
                    }

                    .tip {
                        font-size: 14px;
                        color: #666666;
                        padding: 0 20px;
                        text-align: left;

                        span {
                            font-size: 24px;
                            color: #f5222d;
                        }
                    }

                    .dask {
                        position: absolute;
                        width: 285px;
                        height: 318px;
                        transition: all 0.5s;
                        bottom: -320px;
                        background-color: #ffffff;
                        border-top: 2px solid #2768ef;

                        .dtitle {
                            font-size: 18px;
                            color: #333333;
                            font-weight: bold;
                            margin: 20px;
                            margin-bottom: 15px;
                            text-align: left;
                        }

                        .guding {
                            height: 180px;
                            text-align: left;

                            .dp {
                                margin: 0 20px;

                                i {
                                    color: #2768ef;
                                    margin-right: 5px;
                                }

                                font-size: 14px;
                                line-height: 26px;
                                color: #666666;
                            }
                        }

                        .d-s {
                            font-size: 14px;
                            line-height: 20px;
                            color: #2768ef;
                            margin: 0 20px;
                            margin-top: 20px;
                        }

                        .d-t {
                            font-size: 14px;
                            color: #666666;
                            margin: 0 20px;
                        }

                        .d-tou {
                            width: 110px;
                            height: 40px;
                            line-height: 40px;
                            text-align: center;
                            background-color: #2768ef;
                            border-radius: 5px;
                            border: solid 1px #ffffff;
                            color: #fff;
                            cursor: pointer;
                            margin: 0 20px;
                            margin-top: 0;
                        }
                    }
                }

                .ci-box-item:hover {
                    .dask {
                        bottom: 0px;
                    }
                }
            }
        }
    }

    .company-ad .ci-box-item {
        background: #fff;
    }

    .compang-programme {
        width: 100%;
        /* background: url('@/assets/images/company/banner2.jpg'); */
        background-position: center;
        height: 675px;

        .cp-box {
            margin: auto;
            width: 500px;

            .cp-form {
                .cp-form-item {
                    font-size: 14px;
                    line-height: 50px;
                    color: #ffffff;
                    display: flex;

                    .cp-l {
                        text-align: right;
                        width: 70px;
                    }

                    .cp-r {
                        width: 420px;

                        p {
                            font-size: 14px;
                            line-height: 50px;
                            color: #ff9600;
                        }
                    }
                }

                .cp-btn {
                    width: 210px;
                    height: 55px;
                    line-height: 55px;
                    text-align: center;
                    border-radius: 27px;
                    border: solid 2px #ffffff;
                    color: #fff;
                    margin: auto;
                    cursor: pointer;
                    margin-top: 40px;
                    margin-bottom: 20px;
                }

                .tip {
                    color: #fff;
                    font-size: 16px;
                    text-align: center;

                    span {
                        font-size: 24px;
                        margin: 0 2px;
                    }
                }
            }
        }
    }

    .bingo {
        position: relative;
        top: 3px;
    }
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/customizedEmployerLiability/calssType.vue